module.exports = function(posts) {
	'use strict'
	posts.directive('onScrollLoad',onScrollLoad);
	onScrollLoad.$inject=['getDataService','jQuery','$compile','alertService','serverError','config','$filter','offlineError','refreshtokenService', 'checkArray'];
	function onScrollLoad(getDataService,jQuery, $compile,alertService,serverError,config, $filter,offlineError, refreshtokenService ,checkArray) {
		return {
			restrict: 'A',
			scope:{
				pageNumber:'=',
				currentLoad:'=',
				featuredImg:'=',
				searchData:'=',
				typeSearch:'=',
				selectedAttachment:'=',
				appState:'=',
				category:'=',
				maxPages:'=',
				scheduled:'=',
				onScrollLoading:'='			
			},
			link: function(scope, ele, $attrs, ctrl) {
				scope.config = config;
				// scope.pageCount=1000;		
				var s,type,uploaded_to;
				var category;
				scope.mediaItemsPage = [];
				var scrollTolerance = 5; //zoom page has rounding issues
				var isAtBottom = false; // to not trigger twice
				scope.onScrollAction =  function() {                                              
	                if((this.scrollHeight - this.scrollTop <= this.clientHeight + scrollTolerance) && ((scope.appState == 'attachments' && scope.selectedAttachment == 'all') || scope.appState != 'attachments')){
						if (!isAtBottom) {
							isAtBottom = true;
							scope.$apply(function() {
								scope.pageNumber++
								scope.loadMoreData();
								console.log('scrool-load-more', scope.pageNumber)	
							})
						}
	                } else {
						isAtBottom = false;
					}
	            };
	            angular.element(ele).on('scroll', scope.onScrollAction)
				scope.loadMoreData = function() {
					if(scope.appState == 'attachments') {
						if(scope.searchData) {
							if(scope.searchData.length>0) {
				              s = scope.searchData.toLowerCase();
				              if(scope.typeSearch) {
				              	type='all'
				              } else {
				              	type=null;
				              }
				            } else if(scope.searchData.length==0){
				              s = null;
				              type = null;
				            }
						} else {
							s = null;
				            type = null;
						}
						if(scope.selectedAttachment =='all') {
							uploaded_to = null
						} else {
							uploaded_to=scope.selectedAttachment
						}
					} else {
				        type = null;
				        uploaded_to = null
						if(scope.searchData) {
							if(scope.searchData.length>0) {
				              s = scope.searchData.toLowerCase();

				            } else if(scope.searchData.length==0){
				              s = null;
				            }
						} else {
							s = null;
						}
						if(scope.category) {
							if(scope.category =='all') {
								category =null;
							} else {
								category = scope.category;
							}
						}
					}
					if(scope.pageNumber<=scope.maxPages) {
						scope.onScrollLoading = true;
						var getFunction = function() {
							getDataService.get({
					            param1: (scope.appState=='attachments')? scope.appState: 'video',
					            param2: null,
					            limit: 100,
					         	page:scope.pageNumber,
					         	s:s,
					         	type:type,
			         			uploaded_to:uploaded_to,
			         			status: (scope.appState == 'videos' && scope.scheduled)? 'publish,schedule':(scope.appState == 'videos' && !scope.scheduled)? 'publish': null,
			         			category:category  
				            }).$promise.then(function(data){
				            	if(scope.appState=='attachments') {
					            	for(var i=0;i<data[scope.appState].length;i++) {
					            		if(scope.featuredImg==data[scope.appState][i]._id) {
					            			data[scope.appState].splice(i,1);
					            			break
					            		}
					            	}
				            	}
				            	if(scope.appState=='videos') {
				            		for(var i=0; i<data[scope.appState].length;i++) {
				                    data[scope.appState][i].thumb=scope.config.baseVideoHref + data[scope.appState][i].image.replace('.jpg','-254x191.jpg'); 
				                    data[scope.appState][i].file_video = scope.config.baseVideoHref + data[scope.appState][i].file.m3u8; 
				                    data[scope.appState][i].dateFormated = $filter('date')(data[scope.appState][i].date, "MMM d, y HH:mm")
				                    if(data[scope.appState][i].duration){
				                      var formatedTime;
				                      if(data[scope.appState][i].duration>=3600) {
				                        formatedTime = 'H:mm:ss'
				                      } else{
				                        formatedTime = 'm:ss'
				                      } 
				                      data[scope.appState][i].formated_duration = moment().startOf('day').second(data[scope.appState][i].duration).format(formatedTime);
				                    }
				                  }
				            	}
					            scope.currentLoad = checkArray.removeObjArryDuplicate(scope.currentLoad.concat(data[scope.appState]))
								scope.onScrollLoading = false;
					            // scope.pageCount = data.max_pages;
				          	}, function(error){
								if(!window.navigator.onLine) {
									offlineError()
									return
								}
					            if(error.status == 401) {
					              var promise = refreshtokenService.getAccessToken();
					                promise.then(
				                  	function(answer) {
				                    	if(answer==200) {
				                      		getFunction();                      
				                    	}
				                  	},
				                  	function(error) {
				                    // report something
				                  	},
				                  	function(progress) {
				                   // report progress
				                  	});
					            } else if(error.status ==502) {
                					serverError();
              					} else {
                					alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              					}
								scope.onScrollLoading = false;
					        });
						}
						getFunction();
	        		}
				}
				scope.$on('$destroy', function() {
			      angular.element(ele).off('scroll', scope.onScrollAction);
			    });
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/onScrollLoadDirective.js
// module id = 558
// module chunks = 0